import React from 'react';

import { FaBehance,FaDribbble,FaInstagram,FaLinkedinIn,FaYoutube,FaFacebookF,FaTiktok} from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <div className="social__cover"><a href="https://www.behance.net/praveenpremasinghe" target="_blank" rel='noreferrer'><FaBehance /></a></div>
      <div className="social__cover"> <a href="https://dribbble.com/Praveen-Premasinghe" target="_blank" rel='noreferrer'><FaDribbble /></a></div>
      <div className="social__cover"> <a href="#" target="_blank" rel='noreferrer'><FaInstagram /></a></div>
      <div className="social__cover"> <a href="https://www.linkedin.com/in/praveen-premasinghe-3603b2185/" target="_blank" rel='noreferrer'><FaLinkedinIn /></a></div>
      <div className="social__cover"> <a href="https://youtube.com/@smilewithkaluwa2858" target="_blank" rel='noreferrer'><FaYoutube /></a></div>
      <div className="social__cover"> <a href="https://www.facebook.com/praveen.rajaka.7?mibextid=LQQJ4d" target="_blank" rel='noreferrer'><FaFacebookF /></a></div>
      <div className="social__cover"> <a href="http://www.tiktok.com/@imkaluwa" target="_blank" rel='noreferrer'><FaTiktok /></a></div>
    </div>
  )
};

export default HeaderSocials;